
export const MYSTABLE_EMAIL_UNSUBSCRIBE = "MYSTABLE_EMAIL_UNSUBSCRIBE"
export const MYSTABLE_EMAIL_UNSUBSCRIBE_SUCCESS = "MYSTABLE_EMAIL_UNSUBSCRIBE_SUCCESS"
export const MYSTABLE_EMAIL_UNSUBSCRIBE_FAIL = "MYSTABLE_EMAIL_UNSUBSCRIBE_FAIL"

export const myStableEmailUnsubscribe = (email = null, token = null) => {
    return {type: MYSTABLE_EMAIL_UNSUBSCRIBE, token, email}
}


// WEBPACK FOOTER //
// ./modules/HorseRacing/actions/myStable.js